'use client';

import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { ChevronDown } from '@/app/components/icons/ChevronDown';
import { SITE } from '@/app/constants';
import { cn } from '@/app/utils';

const FAQ_KEYS = ['q1', 'q2', 'q3', 'q4', 'q5', 'q6'] as const;

const MAAS_LIVE_URL =
  SITE === 'china' ? 'https://platform.vidu.cn/docs/vidu-s1' : 'https://platform.vidu.com/docs/vidu-s1';

const FAQ_LINK_CLASS = 'text-[#0086FF] underline underline-offset-2 hover:text-[#3aa0ff]';

export function QuestionSection() {
  const t = useTranslations('vidu-stream');
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="relative w-full bg-black px-8 py-20 text-white sm:px-4 sm:py-12">
      {/* 上下排列：标题在上，手风琴列表在下 */}
      <div className="mx-auto flex w-full max-w-[820px] flex-col">
        <h2 className="mb-10 text-center font-semibold text-[40px] leading-[1.2] sm:mb-8 sm:text-[28px]">
          {t('faq.title')}
        </h2>

        <div className="divide-y divide-white/10 border-white/10 border-y">
          {FAQ_KEYS.map((key, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={key}>
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                  className="flex w-full cursor-pointer items-center justify-between gap-6 px-2 py-[30px] text-left sm:py-5"
                >
                  <span className="flex-1 font-medium text-xl leading-7 sm:text-base">{t(`faq.${key}.title`)}</span>
                  <ChevronDown
                    className={cn(
                      'size-4 shrink-0 text-white transition-transform duration-300',
                      isOpen && 'rotate-180',
                    )}
                  />
                </button>
                <div
                  className="grid transition-[grid-template-rows] duration-300 ease-[cubic-bezier(.33,1,.68,1)]"
                  style={{ gridTemplateRows: isOpen ? '1fr' : '0fr' }}
                >
                  <div className="overflow-hidden">
                    <p className="whitespace-pre-line px-2 pb-8 text-[15px] text-white/60 leading-relaxed sm:pb-5">
                      {key === 'q6'
                        ? t.rich('faq.q6.description', {
                            link: (chunks) => (
                              <a
                                href={MAAS_LIVE_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={FAQ_LINK_CLASS}
                              >
                                {chunks}
                              </a>
                            ),
                          })
                        : t(`faq.${key}.description`)}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
